import { makeStyles } from "@fluentui/react-components";

export const useSuggestionToolbarStyles = makeStyles({
  toolbar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    height: "48px",
  },
  toolbarToggleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignContent: "center",
  },
  toolbarToggleLabel: {
    color: "#242424",
    fontSize: "14px",
    lineHeight: "20px",
    wordWrap: "break-word",
  },
  toggleActive: {
    fontWeight: 600,
  },
});
